var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.1h0c-.5-.8-.7-1.2-1-1.4-.3-.2-.6-.4-.9-.5-.4-.1-.8-.1-1.7-.1h-.9c-.8 0-1.1 0-1.4-.1-.3-.1-.5-.3-.6-.6-.1-.3-.1-.7-.1-1.4V4.2c0-.8 0-1.1.1-1.4.1-.3.3-.5.6-.6.3-.1.7-.1 1.4-.1h.3c1.5 0 2.3 0 2.8.3s.9.7 1.2 1.2c.3.6.3 1.3.3 2.8M9 14.1V6.3m0 7.8h0c.5-.8.7-1.2 1-1.4.3-.2.6-.4.9-.5.4-.1.8-.1 1.7-.1h.9c.8 0 1.1 0 1.4-.1.3-.1.5-.3.6-.6.1-.3.1-.7.1-1.4V4.2c0-.8 0-1.1-.1-1.4-.1-.3-.3-.5-.6-.6-.3-.1-.7-.1-1.4-.1h-.3c-1.5 0-2.3 0-2.8.3s-.9.7-1.2 1.2c-.3.6-.3 1.3-.3 2.8",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFolderIcEmpty;